import { render, staticRenderFns } from "./rmsRevenueApp.vue?vue&type=template&id=a5a35686&scoped=true"
import script from "./rmsRevenueApp.vue?vue&type=script&lang=js"
export * from "./rmsRevenueApp.vue?vue&type=script&lang=js"
import style0 from "./rmsRevenueApp.vue?vue&type=style&index=0&id=a5a35686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a35686",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VRow,VSkeletonLoader})
